<template>
    <div>
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="listing-header is-flex-hright">
                <div class="header-buttons pr-3">
                    <button
                        v-if="permissao.update"
                        @click="save()"
                        :disabled="isSaving"
                        class="save-btn"
                        type="button"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
            <form class="is-flex is-flex-column">
                <div class="is-flex">
                    <div class="column is-6">
                        <v-input v-model="b2bEmpresa.nome" :title="'nome'" :disabled="true" />
                    </div>
                    <div class="column is-6">
                        <v-input v-model="b2bEmpresa.rsocial" :title="'rsocial'" :disabled="true" />
                    </div>
                </div>
                <div class="is-flex">
                    <div class="column is-6">
                        <vss-select
                            :id="generateId(1)"
                            title="tipo-pedido"
                            v-model="b2bEmpresa.tipoPedido"
                            :options="tiposPedido"
                            :loading="tiposPedidoLoading"
                            @search="carregarTipoPedido"
                            @input="updateTipoPedido"
                            searchable
                            :closeOnSelect="true"
                        />
                    </div>
                    <div class="column is-6">
                        <vss-select
                            :id="generateId(2)"
                            title="tab-preco"
                            v-model="tabelaPrecoSelected"
                            :options="tabelasPreco"
                            :loading="tabelasPrecoLoading"
                            @search="carregarTabelaPreco"
                            @input="updateTabelaPreco"
                            searchable
                            :closeOnSelect="true"
                        />
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import B2BEmpresaService from '@/services/b2b/B2BEmpresaService';
import TipoPedidoService from '@/services/vendas/TipoPedidoService';
import TabPrecoService from '@/services/vendas/tabpreco/TabPrecoService';

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            service: new B2BEmpresaService(this.$http, this.$router),
            tipoPedidoService: new TipoPedidoService(this.$http, this.$router),
            tabelaPrecoService: new TabPrecoService(this.$http, this.$router),
            permissao: {},
            isLoading: false,
            tiposPedidoLoading: false,
            tabelasPrecoLoading: false,
            isSaving: false,
            b2bEmpresa: {},
            novasAssociacoes: {},
            tiposPedido: [],
            tabelasPreco: [],
            tabelaPrecoSelected: {},
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('b2b', 'b2b-politica-comercial-edit');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'dados-iniciais' },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        carregarDados() {
            this.isLoading = true;

            this.service
                .find(this.$route.params.id)
                .then((response) => {
                    const { idB2BEmpresa, ...rest } = response.content;

                    this.b2bEmpresa = { id: idB2BEmpresa, ...rest };

                    // [Desestruturação de objeto]
                    const { idEmpresa, idTipoPedido, idTabPreco } = this.b2bEmpresa;

                    this.novasAssociacoes = {
                        idEmpresa,
                        idB2BEmpresa,
                        idTipoPedido,
                        idTabPreco,
                    };
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados!');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        carregarTipoPedido() {
            this.tiposPedidoLoading = true;

            this.tipoPedidoService
                .findAllCombo()
                .then(this.mapTipoPedidoResponseContent)
                .then((mappedContent) => {
                    this.tiposPedido = mappedContent;
                })
                .catch((error) => {
                    console.error('Erro ao carregar tipos de pedido.', error);
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.tiposPedidoLoading = false;
                });
        },
        carregarTabelaPreco() {
            this.tabelasPrecoLoading = true;

            this.tabelaPrecoService
                .findAllComboTabPreco()
                .then(this.mapTabelaPrecoResponseContent)
                .then((mappedContent) => {
                    this.tabelasPreco = mappedContent;

                    this.tabelaPrecoSelected = this.tabelasPreco.find(
                        (tabela) => tabela.id === this.b2bEmpresa.idTabPreco
                    );
                })
                .catch((error) => {
                    console.error('Erro ao carregar tabelas de preço.', error);
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.tabelasPrecoLoading = false;
                });
        },
        mapTipoPedidoResponseContent(response) {
            return response.content.map((element) => ({
                id: element.idtipopedido,
                label: element.descricao,
                descricao: element.descricao,
            }));
        },
        mapTabelaPrecoResponseContent(response) {
            return response.content.map((element) => ({
                id: element.idtabpreco,
                label: element.descricao,
                descricao: element.descricao,
            }));
        },
        updateTipoPedido(tipoPedido) {
            this.novasAssociacoes.idTipoPedido = tipoPedido.id;
        },
        updateTabelaPreco(tabelaPreco) {
            this.novasAssociacoes.idTabPreco = tabelaPreco.id;
        },
        generateId(numberId) {
            return this.$route.name + numberId;
        },
        save() {
            this.isSaving = true;
            this.isLoading = false;

            this.service
                .save(this.novasAssociacoes)
                .then((value) => {
                    if (value.message == null) {
                        this.$root.showMessage('success', 'msg-edit-empresa');
                        this.$emit('isChanged', false);
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('alert', e.body.message, true);
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.pr-3 {
    padding-right: 12px;
}
</style>
